module.exports = __webpack_public_path__ + "media/images/flags/ng-46f0df63716157cb114cd9150e2be993.svg";